export const CHARACTERS = [
  {
    id: "xiaoxiwei",
    name: "小曦薇",
    person: "田曦薇",
    fullName: "田曦薇 Windows 互动角色",
    tagline: "陪伴你的桌面时光，与你自然互动",
    description:
      "写实风格的 Windows 互动角色，支持拖动、凝视、挥手、手机、睡眠和多套造型切换。",
    version: "v3.0.6",
    repoUrl: "https://github.com/super-idol-hub/xiaoxiwei",
    releaseUrl: "https://github.com/super-idol-hub/xiaoxiwei/releases/latest",
    downloadUrl:
      "https://github.com/super-idol-hub/xiaoxiwei/releases/download/v3.0.6/XiaoXiWei-v3.0.6.exe",
    skins: [
      { id: "white-dress", name: "vivo 白裙" },
      { id: "linan-princess", name: "临安公主" },
      { id: "huang-chengzi", name: "黄橙子" },
    ],
  },
  {
    id: "xiaotaiyan",
    name: "小泰妍",
    person: "金泰妍",
    fullName: "金泰妍 Windows 互动角色",
    tagline: "粉蓝周末与月影舞台，留在你的桌面",
    description:
      "一个 EXE 内置 Weekend 与 INVU 双造型，包含完整动作、平滑切换和自然的桌面互动。",
    version: "v1.1.1",
    repoUrl: "https://github.com/super-idol-hub/xiaotaiyan",
    releaseUrl: "https://github.com/super-idol-hub/xiaotaiyan/releases/latest",
    downloadUrl:
      "https://github.com/super-idol-hub/xiaotaiyan/releases/download/v1.1.1/XiaoTaeyeon-v1.1.1.exe",
    skins: [
      { id: "weekend", name: "Weekend" },
      { id: "invu", name: "INVU" },
    ],
  },
  {
    id: "xiaoluhan",
    name: "小鹿晗",
    person: "鹿晗",
    fullName: "鹿晗 Windows 互动角色",
    tagline: "两套正式礼服，一份克制而自然的陪伴",
    description:
      "写实 Windows 互动角色，一个 EXE 内置黑色西装与白色礼服双造型及完整动作。",
    version: "v3.1.2",
    repoUrl: "https://github.com/super-idol-hub/xiaoluhan",
    releaseUrl: "https://github.com/super-idol-hub/xiaoluhan/releases/latest",
    downloadUrl:
      "https://github.com/super-idol-hub/xiaoluhan/releases/download/v3.1.2/XiaoLuhan-v3.1.2.exe",
    skins: [
      { id: "black-suit", name: "黑色西装" },
      { id: "white-formal", name: "白色礼服" },
    ],
  },
];
